import { useEffect } from 'react';
import { observer } from 'mobx-react';
import {
  StandardDialog,
} from '@roc/ui';
import { useDrawsStore } from '../hooks';
import { DrawReviewReportShared } from '../drawReviewReport/components/drawReviewReportShared';
import { useRocInternalPortalStore } from "apps/roc-internal-portal/src/app/hooks";
import { useBaseStore } from '@roc/feature-app-core';
import { Document } from '@roc/feature-types';
import { DrawRequestFormShared } from '../drawRequestForm/drawRequestFormShared';
import { useDocumentStore } from '@roc/feature-documents';
import { makeStyles } from '@material-ui/core/styles';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

interface DrawReportDialogProps {
  open: boolean;
  onClose: () => void;
  document: Document;
}

const useStyles = makeStyles(() => ({
  dialog: {
    '& .MuiDialogContent-root': {
      height: 'calc(90vh - 64px)',
    },
  },
}));

export const DrawReviewReportDialog = observer(({ open, onClose, document }: DrawReportDialogProps) => {
  const classes = useStyles();
  const { drawReviewReportStore, drawRequestStore, drawStore } = useDrawsStore();
  const { drawReviewReportInternalStore } = useRocInternalPortalStore();
  const { globalStore } = useBaseStore();
  const { documentStore } = useDocumentStore();
  const isInternal = globalStore.isInternalPortal;
  const loanId = document?.loanId;
  const drawId = document?.drawId;
  const taskId = document?.taskId;
  const hasInspectionId = !!drawReviewReportInternalStore?.inspectionId;
  useEffect(() => {
    if (drawReviewReportInternalStore && drawId) {
      drawReviewReportInternalStore.reset();
      drawReviewReportInternalStore.loadTableData(drawId);
    }
  }, [drawReviewReportInternalStore]);

  const handleSubmitDrawRequestForm = async (drawType?: string) => {
    await drawRequestStore.submitForm(drawId, drawType);
    drawStore.fetchDrawDTOById(`${drawId}`);
    documentStore.loanTodosStore.fetchLoanDrawTodosPending(loanId);
  };

  const handleSaveDrawRequestForm = async (drawType?: string) => {
    await drawRequestStore.saveForm(drawId, drawType);
    documentStore.loanTodosStore.fetchLoanDrawTodosPending(loanId);
  };

  const dialogContent = isInternal ? (<DrawReviewReportShared
    store={drawReviewReportInternalStore}
    isInternal={isInternal}
    drawId={drawId}
  />) : (<DrawRequestFormShared
    onSubmit={handleSubmitDrawRequestForm}
    onSave={handleSaveDrawRequestForm}
    store={drawRequestStore}
    drawId={drawId}
  />);

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title='Draw Review Report'
          maxWidth={hasInspectionId ? false : 'xl'}
          className={hasInspectionId ? classes.dialog : undefined}
          handleClose={onClose}
          dialogContent={dialogContent}
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          maxWidth={hasInspectionId ? false : 'xl'}
          className={hasInspectionId ? classes.dialog : undefined}
          handleClose={onClose}
          dialogContent={dialogContent}
        />
      )}
    </>
  );
});
